<!-- VEC stands for Verify Email Component -->

<div class="VEC">
    <div class="VEC__header">
        <div class="VEC__title">Verify your email</div>
        <img class="VEC__email-img" src="../../../../assets/Email.png"/>
        <p>We have sent a code to <span class="VEC__email-id">{{ verifyEmailData.email }}</span>. Enter the code
                below to confirm you have access to this email.</p>

        <pin-input class="VEC__password" :length="passwordLength"
            v-model="verificationCode" :placeholder="'#'"
            @onEnterKeyPress="onEnterKeyPress">
        </pin-input>
    </div>
    <div class="VEC__clear VEC__max-width">
        <linear-progress class="VEC__progress" v-if="isRequestInProgress"></linear-progress>
    </div>
    <div class="VEC__content VEC__max-width" ref="tests">
        <h4>Please check your email</h4>
        <p class="">Before you can access your free trail, we need to verify your email
            <br/>address. Please check your inbox for a message from us.
            <br/> You'll find the code.</p>
        <mom-button class="VEC__button-submit" variant="raised" @click="onVerifyEmail" :disabled="isInvalid">Verify</mom-button>
        <p>Didn’t receive any email?</p>
        <span class="VEC__resend" @click="resendEmail">Re-send Email</span>
    </div>
</div>
